import { TransformationTypes } from "../../../../workers/preprocessImage";

export const labelTransformations = [
    TransformationTypes.GRAYSCALE
];

export const valveSerialTransformations = [
    TransformationTypes.THRESHOLD,
    TransformationTypes.GRAYSCALE,
    TransformationTypes.INVERT
];

export const valvePrefixTransformations = [
    TransformationTypes.GRAYSCALE,
    TransformationTypes.INVERT,
];

export const cordCylinderTransformations = [];

export const tagSerialTransformations = [
    TransformationTypes.GRAYSCALE,
    TransformationTypes.INVERT
];

export const regexConfigs = [
    { item_number: "9.1185.0467.0", field: "serial", side: "Tag", regex: /[^a-zA-Z\s\d]?([A-Z]{1,2}\d{7})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1189.0295.0", field: "serial", side: "Tag", regex: /[^a-zA-Z\s\d]?([A-Z]{1,2}\d{6,7})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1189.0339.0", field: "serial", side: "Tag", regex: /[^a-zA-Z\s\d]?([A-Z]{1,2}\d{7,8})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1185.0465.0", field: "serial", side: "Tag", regex: /([A-Z]{1,2}\d{7})/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1185.0454.2", field: "serial", side: "Tag", regex: /[^a-zA-Z\s\d]?([A-Z]{1,2}\d{7})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1185.0453.0", field: "serial", side: "Tag", regex: /([A-Z]{1,2}\d{7})/, cleaning: "$1", transformations: tagSerialTransformations },
    { item_number: "9.1185.0453.1", field: "serial", side: "Tag", regex: /([A-Z]{1,2}\d{7})/, cleaning: "$1", transformations: tagSerialTransformations },
    // Valve 9.1138.0467.0 — front prefix: date MM-YY only for both variants; back serial differs by variant
    { item_number: "9.1138.0467.0", field: "prefix", side: "Front", sticker_variant: "ocr", regex: /[^a-zA-Z\s\d]?((0[1-9]|1[0-2])-(2[0-1])\d{2})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: valvePrefixTransformations },
    { item_number: "9.1138.0467.0", field: "serial", side: "Back", sticker_variant: "ocr", regex: /[^a-zA-Z\s\d]?(P\d{7}|[A-Z0-9]{11})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: valveSerialTransformations },
    { item_number: "9.1138.0467.0", field: "prefix", side: "Front", sticker_variant: "datamatrix", regex: /[^a-zA-Z\s\d]?((0[1-9]|1[0-2])-(2[0-1])\d{2})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: valvePrefixTransformations },
    { item_number: "9.1138.0467.0", field: "serial", side: "Back", sticker_variant: "datamatrix", regex: /[^a-zA-Z\s\d]?([A-Z0-9]{11})[^a-zA-Z\s\d]?/, cleaning: "$1", transformations: valveSerialTransformations },
    { item_number: "5.1005.5071.0", field: "serial", side: "Datamatrix", regex: /(\d{8})/, cleaning: "$1", transformations: cordCylinderTransformations },
];

export const MULTI_LINE_SERIAL = ["9.1189.0295.0", "9.1189.0339.0"];

export const isCordCylinder = (item_number) => item_number === "5.1005.5071.0";

export function preprocessText(text, isLabel) {
    let filteredText = text
        .replace("https://pk.festo.com/", "")
        .toUpperCase()
        .replace(/[|{}$]/g, 'J')
        .replace(/°/g, 'P')
        .replace(/\?/g, '2')
        .replace(/@/g, 'Q')
        .trim();

    if (isLabel) {
        filteredText = filteredText
            .replace(/[\r\n]+/g, '')
            .replace(/\s+/g, '')
            .replace(/[^A-Z0-9.-]/g, '');
    }
    return filteredText;
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertStringToJSONObject(inputString) {
    const keyValuePairs = inputString.split(';');
    const jsonObject = {};
    for (const pair of keyValuePairs) {
        const [key, value] = pair.trim().replace(/(\$|'| )/g, '').split('=');
        if (key && value) {
            jsonObject[key] = value;
        }
    }
    return jsonObject;
}

export function getRegex(user, side, meta, item_number, valve_sticker_variant) {
    const variantKey = valve_sticker_variant === 'qr' ? 'ocr' : valve_sticker_variant;
    if (side === "SOMINT-label") {
        const regex = [
            { field: "item_number", regex: /((9\.1|5\.1|5\.2|5\.4|5\.9|9\.5)\d{3}\.\d{4}[.\w]\d)/, cleaning: "$1" },
            { field: "a_number", regex: /(\d{13})/, cleaning: "$1" },
        ];
        if (!user.center.is_lna) {
            regex.push({ field: "warranty_request", regex: /(WR\d{5})/, cleaning: "$1" });
        }
        return [regex, labelTransformations];
    }
    if (side === "SMART-label") {
        return [[
            { field: "item_number", regex: /((9\.1|5\.1|5\.2|5\.4|5\.9|9\.5)\d{3}\.\d{4}[.\w]\d)/, cleaning: "$1" },
            { field: "warranty_request", regex: /(C+\d{6,7})/, cleaning: "$1" },
            { field: "a_number", regex: /(N|R)+(\d{6,7}-\d{3})/, cleaning: "$1$2" }
        ], labelTransformations];
    }
    if (side === "COMPASS_QR-label") {
        return [[
            { field: "item_number" },
            { field: "warranty_request" },
            { field: "a_number" },
            { field: "work_date" }
        ], []];
    }
    if (side === "COMPASS_BARCODE-label") {
        return [[
            { field: "item_number" },
            { field: "warranty_request" },
            { field: "a_number" },
        ], []];
    }
    if (meta?.use_OCR) {
        const config = regexConfigs.find(i =>
            i.item_number === item_number &&
            i.field === meta.name &&
            i.side === side &&
            (!i.sticker_variant || i.sticker_variant === variantKey)
        );
        if (config) {
            return [[{ ...config, result: meta.scanned }], config.transformations];
        }
        return [regexConfigs, labelTransformations];
    }
    return [[], []];
}
